var $ = require('jquery');

$(function () {
  // Place this somewhere which will be run on every page
  $('body').on('click', '.ripple', function (event) {
    var color = $(this).data().color || 'white';
    var $ripple = $('<div />').addClass('ripple-effect');
    var btnOffset = $(this).offset();
    var xPos = event.pageX - btnOffset.left;
    var yPos = event.pageY - btnOffset.top;
    var size = $(this).height();

    $ripple
      .width(size)
      .height(size)
      .css({
        top: yPos - size / 2,
        left: xPos - size / 2,
        backgroundColor: color,
      })
      .appendTo(this);

    setTimeout(function () {
      $ripple.remove();
    }, 2000);
  });
});
